// extracted by mini-css-extract-plugin
module.exports = {"screen":"App_screen__2g4e4","overlay":"App_overlay__2Yat2"};